<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-spectrum/icon';
import {HeaderInfo, HeaderTable, PropTable} from '@react-spectrum/docs';
import packageData from '../package.json';
import workflowIconPackageData from '@spectrum-icons/workflow/package.json';

```jsx import
import {Icon} from '@react-spectrum/icon';
import IconTable from './IconTable';
```

---
category: Misc
---

# Icon

<p>{docs.exports.Icon.description}</p>

## Available Icons

### Workflow

<HeaderInfo
  packageData={workflowIconPackageData}
  sourceData={[
    {type: 'Spectrum', url: 'https://spectrum.adobe.com/page/icons/'}
  ]} />

<br />

Spectrum workflow icons are graphical metaphors or symbols that users interact with to navigate and manipulate objects.
They all appear at the same size within each platform, 18 px for desktop and 22 px for mobile. See [ActionButton](/react-spectrum/ActionButton.html#content)
and [Picker](/react-spectrum/Picker.html#complex-items) for some examples of icon usage within React Spectrum components.

See the table below for a full list of available workflow icons.

```tsx snippet
<IconTable iconPackage="workflow" />
```
